<template>
  <div class="comp-accordion">
    <div class="item" v-for="(item, idx) in items" :key="`item-${idx}`">
      <div class="question" @click="handleItemClick(idx)">
        <span v-html="item.question" />
        <Icon name="chevronRight" />
      </div>
      <div class="answer">
        <template v-if="item.answer.type === 'text'">
          <div class="text" v-html="item.answer.value" />
        </template>
        <template v-else-if="item.answer.type === 'video'">
          <div class="video">
            <iframe
              :src="`https://player.vimeo.com/video/${item.answer.value}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`"
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
            />
            <br/>
            <div>
              <Icon name="info"/>
              <p>Bitte deaktivieren Sie eventuell aktivierte Ad-Blocker, da diese die fehlerfreie Wiedergabe des Videos beeinträchtigen könnten.</p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'Accordion',
    components: {
      Icon,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      items: {
        type: Array,
        default: () => [],
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        timeoutId: null,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      handleItemClick(index) {
        const CSS_CLASS = 'open';
        clearTimeout(this.timeoutId);
        const items = this.$el.querySelectorAll('.item');
        const item = items[index];
        if (item.classList.contains(CSS_CLASS)) {
          item.classList.remove(CSS_CLASS);
        } else {
          items.forEach(i => i.classList.remove(CSS_CLASS));
          item.classList.add(CSS_CLASS);
          this.timeoutId = setTimeout(() => {
            const answer = item.querySelector('.answer');
            answer.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
          }, 600);
        }
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.comp-accordion {
  margin-top: 4px;
  .item {
    width: 100%;
    border-bottom: 1px solid $color-black-alpha-10;
    &:last-of-type {
      border-bottom: 1px solid transparent;
    }
    & > .question {
      padding: 24px 12px;
      width: 100%;
      position: relative;
      user-select: none;
      cursor: pointer;

      & > span {
        @include font-body-large-bold;
        color: $color-black-alpha-80;
        margin: 24px 0;
      }
      & > svg {
        right: 12px;
        position: absolute;
        width: 24px;
        height: 24px;
        transform: rotate(0deg);
        transition: transform 0.6s ease;
      }
    }
    & > .answer {
      width: 100%;
      max-height: 0;
      overflow: hidden;
      transition: all 0.3s ease-out;
      box-shadow: $box-shadow-2;

      & > div {
        padding: 24px;
        opacity: 0;
        transition: opacity 0.3s ease-out;

        &.text {
          @include font-body-large;
          color: $color-black-alpha-80;
          width: 100%;
          a { display: inline-block; margin-top: auto; overflow: visible; }
        }

        &.video {
          text-align: center;
          & > iframe {
            aspect-ratio: 16/9;
            width: 100%;
            max-width: 1080px;
            height: auto;
          }
          & > div {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 16px;
            margin: 0 auto;
            max-width: 80%;
            & > svg {
              position: relative;
              min-width: 24px;
              max-width: 24px;
              width: 24px;
              height: 24px;
            }
            & > p {
              text-align: left;
            }
          }
        }
      }
    }

    &.open {
      & > .question {
        background-color: $color-blue-alpha-10;
        border-bottom: 1px solid $color-blue-solid-100;
        & > svg {
          transform: rotate(90deg);
        }
      }
      & > .answer {
        max-height: 100vh;
        transition: all 0.6s ease-in;

        & > div {
          transition: opacity 0.3s ease-in;
          opacity: 1;
        }
      }
    }
  }
}
</style>
